var _linearGradient, _path, _linearGradient2, _path2, _path3, _path4, _path5, _path6, _path7, _linearGradient3, _circle, _path8, _linearGradient4, _path9, _circle2, _circle3, _circle4, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Appliance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    x1: 20,
    x2: 20,
    y1: 19.936,
    y2: 48.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#28afea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b88da"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M32,43H8c-1.1,0-2-0.9-2-2V22h28v19C34,42.1,33.1,43,32,43z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    x1: 20,
    x2: 20,
    y1: 5.128,
    y2: 41.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#28afea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b88da"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_2_)",
    d: "M34,20H6V7c0-1.1,0.9-2,2-2h24c1.1,0,2,0.9,2,2V20z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0078d4",
    d: "M6,20h28v2H6V20z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27,24c-1.7,0-3,1.3-3,3v14c0,0.8,0.3,1.5,0.8,2H32c1.1,0,2-0.9,2-2V24H27z",
    opacity: 0.05
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27,24.5c-1.4,0-2.5,1.1-2.5,2.5v14c0,0.8,0.4,1.5,1,2H32c1.1,0,2-0.9,2-2V24.5H27z",
    opacity: 0.07
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#50e6ff",
    d: "M27,25h13c1.1,0,2,0.9,2,2v14c0,1.1-0.9,2-2,2H27c-1.1,0-2-0.9-2-2V27C25,25.9,25.9,25,27,25z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36.5,26h3c0.3,0,0.5,0.2,0.5,0.5v1c0,0.3-0.2,0.5-0.5,0.5h-3c-0.3,0-0.5-0.2-0.5-0.5v-1 C36,26.2,36.2,26,36.5,26z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    x1: 27.939,
    x2: 38.958,
    y1: 35.477,
    y2: 35.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3079d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#297cd2"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.4,
    cy: 35.5,
    r: 5.5,
    fill: "url(#SVGID_3_)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#184f85",
    d: "M33.4,32c-1.9,0-3.5,1.6-3.5,3.5c0,1.9,1.6,3.5,3.5,3.5s3.5-1.6,3.5-3.5C36.9,33.6,35.4,32,33.4,32z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    x1: 36,
    x2: 38,
    y1: 35.5,
    y2: 35.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3079d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#297cd2"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_4_)",
    d: "M36.6,37H38v-3h-1.4c-0.3,0-0.6,0.3-0.6,0.6v1.8C36,36.7,36.3,37,36.6,37z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 26.5,
    r: 0.5,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 26.5,
    r: 0.5,
    fill: "#fff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 26.5,
    r: 0.5,
    fill: "#fff"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#0078d4",
    d: "M10.5,36h-1C9.2,36,9,35.8,9,35.5v-9C9,26.2,9.2,26,9.5,26h1c0.3,0,0.5,0.2,0.5,0.5v9C11,35.8,10.8,36,10.5,36z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#0078d4",
    d: "M10.5,16.1h-1c-0.3,0-0.5-0.2-0.5-0.5v-5c0-0.3,0.2-0.5,0.5-0.5h1c0.3,0,0.5,0.2,0.5,0.5v5 C11,15.8,10.8,16.1,10.5,16.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Appliance);
export default __webpack_public_path__ + "static/media/icons8-appliance.109d83f7dc40f5448bbb744d0f1c3194.svg";
export { ForwardRef as ReactComponent };